import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import ServiceDetail from "@/pages/ServiceDetail";
import { Login, Register, ForgotPassword, ResetPassword, VerifyEmail } from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import PortalLayout from "@/pages/portal/PortalLayout";
import Dashboard from "@/pages/portal/Dashboard";
import Assets from "@/pages/portal/Assets";
import Quotes from "@/pages/portal/Quotes";
import AdminQuotes from "@/pages/portal/AdminQuotes";
import AdminAssets from "@/pages/portal/AdminAssets";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30000, refetchOnWindowFocus: false } },
});

function AppRoutes() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/insights" element={<Insights />} />
      <Route path="/services/:slug" element={<ServiceDetail />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route
        path="/portal"
        element={
          <ProtectedRoute>
            <PortalLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="assets" element={<Assets />} />
        <Route path="quotes" element={<Quotes />} />
        <Route path="admin/quotes" element={<AdminQuotes />} />
        <Route path="admin/assets" element={<AdminAssets />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <SmoothScroll>
              <AppRoutes />
            </SmoothScroll>
          </BrowserRouter>
          <Toaster position="bottom-right" theme="dark" />
        </AuthProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
